import { isArray, isBoolean, isString } from 'lodash';

const sportHomePages = {
    'horse-racing': 'meetings',
    greyhounds: 'meetings',
    'in-play': 'inPlay',
    homepage: 'home',
    default: 'highlights',
};

const isShownOnAllPages = showOnAllPages =>
    (isArray(showOnAllPages) && showOnAllPages.length) ||
    (isBoolean(showOnAllPages) && showOnAllPages);

export const isSportHomePage = (sportEn, page) => {
    const homePage = sportHomePages[sportEn] || sportHomePages.default;
    return homePage === page;
};

export const checkSeoBoxDataExistence = data => data && data.bottom_h2;

export const filterSubfeatures = (subfeatures, sportEn, showCustomContent) =>
    subfeatures.filter((subFeature) => {
        if (isShownOnAllPages(subFeature.showOnAllPages)) {
            return subFeature;
        }

        if (showCustomContent) {
            return subFeature.sectionTitle.startsWith('Premier League');
        }

        if (subFeature.selectSports && isString(subFeature.selectSports[0])) {
            return subFeature.selectSports.includes(sportEn);
        }

        return subFeature.selectSports && subFeature.selectSports.some(sports => sports.label === sportEn);
    });
